import React from 'react';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';

import caseStudiesAssets from 'marketing-website/configs/caseStudies';
import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck';

import Image from '../../Image';
import Quote from '../../Quote';

export default function ImageQuoteBlock({ name, caption }) {
  const assets = caseStudiesAssets[name];
  const { quoteImage: image } = assets;
  return (
    <Spacing size="xl" position="topBottom" type="padding">
      <PageWrap>
        <Grid columns={2} size="l">
          <GridItem columnSpan={2} columnSpanM={1} alignContent="center">
            <Image
              hasShadow={false}
              color="snow--d"
              {...image}
              useImageTag={true}
            />
          </GridItem>
          <GridItem columnSpan={2} columnSpanM={1} alignContent="center">
            <Quote content={caption} />
          </GridItem>
        </Grid>
      </PageWrap>
    </Spacing>
  );
}

ImageQuoteBlock.propTypes = {
  name: propTypeEmptyString,
  caption: propTypeEmptyString,
};



// WEBPACK FOOTER //
// ./src/components/modules/ContentBlocks/ImageQuote/index.js